





























import { Component } from 'vue-property-decorator';
import { JournalEntriesModule } from '@/store/Accounting/JournalEntriesModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import JournalEntryDetails from '@/components/Accounting/JournalEntries/JournalEntryDetails.vue';

@Component({ name: 'JournalEntry', components: { Alert, JournalEntryDetails }, metaInfo: { title: 'Journal Entries' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await JournalEntriesModule.getJournalEntry(this.$route.params.id);
    }

    get journalEntry() {
        return JournalEntriesModule.journalEntry;
    }

    get loading() {
        return JournalEntriesModule.loadingJournalEntry;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
